// extracted by css-extract-rspack-plugin
export default {"wrapper":"WBJ3xNGNAKwILxt4","text":"VRsArE2kY7YbcJKm","date_picker":"Njt3WMY8LZ4LZXnV"};